<template>
  <div class="outCar">
    <QS-scroller-box>
      <QS-h3-title>
        <template slot="title">发车出库</template>
        <div class="splitline" />
      </QS-h3-title>
      <div class="item info">
          <el-form ref="stockRef" :model="stock" :rules="rulesStock">
            <column-box :labelWidth="160" :column="2">
              <el-form-item
                prop="actualTakeOverName"
                :label="'提车人姓名' + columnSeparator"
              >
                <el-input
                  v-model="stock.actualTakeOverName"
                  clearable
                  maxlength="20"
                  placeholder="请输入"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                prop="actualTakeOverTel"
                :label="'提车人联系电话' + columnSeparator"
              >
                <el-input
                  v-model="stock.actualTakeOverTel"
                  clearable
                  v-number:phone
                  placeholder="请输入"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                prop="takeOverManager"
                :label="'交接车管' + columnSeparator"
              >
                <el-select
                  v-model="stock.takeOverManager"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="item in carTubeList"
                    :label="item.userName"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                prop="displayMile"
                :label="'表显里程' + columnSeparator"
              >
                <el-input
                  v-number:km
                  v-model="stock.displayMile"
                  placeholder="请输入"
                  clearable
                >
                  <template slot="append">公里</template>
                </el-input>
              </el-form-item>
              <el-form-item
                prop="remainingReserves"
                :label="'剩余电量/油量' + columnSeparator"
              >
                <el-input
                  v-model="stock.remainingReserves"
                  clearable
                  maxlength="20"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                prop="takeOverTime"
                :label="'交接完成时间' + columnSeparator"
              >
                <el-date-picker
                  v-model="stock.takeOverTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="请选择"
                  clearable
                ></el-date-picker>
              </el-form-item>

              <el-form-item prop="hasKey" :label="'车钥匙' + columnSeparator">
                <el-radio-group v-model="stock.hasKey">
                  <el-radio :label="1">有钥匙</el-radio>
                  <el-radio :label="0">无钥匙</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="hasCarLicense" :label="'行驶证' + columnSeparator">
                <el-radio-group v-model="stock.hasCarLicense">
                  <el-radio :label="1">有行驶证</el-radio>
                  <el-radio :label="0">无行驶证</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item
                prop="remarks"
                :label="'备注' + columnSeparator"
                class="textare205"
              >
                <el-input
                  v-model="stock.remarks"
                  type="textarea"
                  placeholder="请输入内容"
                  maxlength="500"
                  show-word-limit
                  clearable
                >
                </el-input>
              </el-form-item>
            </column-box>
          </el-form>
        </div>
         <div class="fileUpload">
          <div class="txt">{{ `验车交接文件${columnSeparator}` }}</div>
            <div>
              <div class="imgList" v-for="(item,index) in checkCarImgData" :key="index">
              <div class="imgList_item" :class="item.urlList.length==1?'hideAdd':''">
                <UploadCommon
                  :fileList="item.urlList"
                  :limit="1"
                  :sizeType="4"
                  :isShowCustom='true'
                  :isAlone="false"
                  @uploadSuccess="checkCarImgDataChange"
                  @deleteUploadHandle="checkCarImgDataChange"
                  commonUpload
                  group="vehicle"
                  code="vehicle_inspection_file"
                />
              </div>
              <div class="imgList_summay">
                <span>说明:</span>
                <el-input
                  style="width:200px;margin-bottom:10px;margin-left:10px"
                    v-model="item.remark"
                    :disabled="item.urlList.length===0"
                    maxlength="200"
                    type="textarea"
                    placeholder="请输入内容"
                    show-word-limit
                    clearable
                  />
              </div>
            </div>
          </div>
        </div>
         <div class="photoUpload">
          <div class="txt">{{ `车辆相关照片${columnSeparator}` }}</div>
            <div>
              <div class="imgList" v-for="(item,index) in aboutCarImgsData" :key="index">
              <div :class="item.urlList.length==3?'hideAdd':''">
                <UploadCommon
                  :fileList="item.urlList"
                  :limit="3"
                  :sizeType="4"
                  :isShowCustom='true'
                  :isAlone="false"
                  @uploadSuccess="isAddImgsItem"
                  @deleteUploadHandle="isAddImgsItem"
                  commonUpload
                  group="order"
                  code="order_vehicle_pic"
                />
              </div>
              <div class="imgList_summay">
                <span>说明:</span>
              <el-input style="width:200px;margin-bottom:10px;margin-left:10px"
                v-model="item.remark"
                :disabled="item.urlList.length===0"
                maxlength="200"
                type="textarea"
                placeholder="请输入内容"
                show-word-limit
                clearable
              />
              </div>
            </div>
          </div>
        </div>
      <template slot="bottomAction">
        <div class="sumbit-btns">
          <el-button @click="cancelHandle(1)" size="small">取消</el-button>
          <el-button
            :loading="oLoading.submit"
            @click="submitStockAddHandle"
            type="primary"
            size="small"
            >发车出库</el-button
          >
        </div>
      </template>
    </QS-scroller-box>
  </div>
</template>

<script>
import { isIntiger, validateMobile } from '@/utils/validate'
// eslint-disable-next-line import/no-cycle
import {
  addOutIn,
  getCarAndContractData,
  editOutIn,
} from '@/api/domain/cars'
import { getAllEmployeeList } from '@/api/carManage/index.js'

export default {
  data() {
    return {
      stockId: '', // 出入库单ID
      carId: '',
      oLoading: {
        submit: false,
      },
      carTubeList: [], // 车管
      // 验车交接文件:
      checkCarImgData: [
        {
          remark: '',
          urlList: [],
        },
      ],
      // 车辆相关照片
      aboutCarImgsData: [
        {
          remark: '',
          urlList: [],
        },
      ],
      stock: {
        displayMile: '',
        takeOverManager: '',
        takeOverTime: '',
        actualTakeOverName: '',
        actualTakeOverTel: '',
        remainingReserves: '',
        hasKey: '', // 是否有钥匙 0无 1有
        hasCarLicense: '', // 是否有行驶证 0无 1有
        remarks: '',
      },
      // 出入库校验
      rulesStock: {
        displayMile: [
          {
            validator: isIntiger,
            trigger: 'blur',
          },
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        takeOverManager: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        takeOverTime: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        hasKey: [
          {
            required: true,
            message: '请选择',
            trigger: 'change',
          },
        ],
        hasCarLicense: [
          {
            required: true,
            message: '请选择',
            trigger: 'change',
          },
        ],
        remarks: [
          {
            required: false,
          },
        ],
        actualTakeOverName: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        actualTakeOverTel: [
          {
            required: true,
            trigger: 'blur',
            validator: validateMobile,
          },
          {
            min: 11,
            max: 11,
            message: '格式不正确',
            trigger: 'blur',
          },
        ],
        remainingReserves: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    const { stockId, id } = this.$route.query
    this.carId = id
    this.stockId = stockId
    this.getCarTubeList()
    this.handleCarAndContractData()
  },
  methods: {
    // 获取交接人和交接人联系方式
    async handleCarAndContractData() {
      const { code, data } = await getCarAndContractData({ carId: this.carId })
      if (code === 1 && data && data.rentOrderVO) {
        const { contactTel, customerName } = data.rentOrderVO
        this.stock = Object.assign({}, this.stock, {
          actualTakeOverName: customerName,
          actualTakeOverTel: contactTel,
        })
      }
    },
    // 新增出库记录
    submitStockAddHandle() {
      this.$refs.stockRef.validate(async (valid) => {
        if (!valid) {
          this.$message.error('请填写必填项')
          return
        }
        this.oLoading.submit = true
        const data = this.parseSendData()
        if (!this.stockId) {
          const { code } = await addOutIn(data)
          this.oLoading.submit = false
          if (code === 1) {
            this.$message.success('添加成功')
            this.$router.back()
          }
        } else {
          const { code } = await editOutIn(data)
          this.oLoading.submit = false
          if (code === 1) {
            this.$message.success('添加成功')
            this.$router.back()
          }
        }
      })
    },
    cancelHandle() {
      this.$router.back()
    },
    // 车辆相关照片
    isAddImgsItem() {
      const groupLimt = 20
      this.aboutCarImgsData.forEach((item, index) => {
        const nextItem = this.aboutCarImgsData[index + 1]
        const preItem = this.aboutCarImgsData[index - 1]
        if (!nextItem && item.urlList.length !== 0 && index !== groupLimt - 1) {
          this.aboutCarImgsData.push({
            remark: '',
            urlList: [],
          })
        }
        if (preItem && preItem.urlList.length === 0) {
          this.aboutCarImgsData.splice(index - 1, 1)
        }
      })
    },
    // 验车交接文件
    checkCarImgDataChange() {
      const groupLimt = 5
      this.checkCarImgData.forEach((item, index) => {
        const nextItem = this.checkCarImgData[index + 1]
        const preItem = this.checkCarImgData[index - 1]
        if (!nextItem && item.urlList.length !== 0 && index !== groupLimt - 1) {
          this.checkCarImgData.push({
            remark: '',
            urlList: [],
          })
        }
        if (preItem && preItem.urlList.length === 0) {
          this.checkCarImgData.splice(index - 1, 1)
        }
      })
    },
    //  获取车管
    async getCarTubeList() {
      const { code, data } = await getAllEmployeeList()
      if (code === 1) {
        this.carTubeList = data
      } else {
        this.$message.error('获取车管失败')
      }
    },
    // 提交需要转换数据
    parseSendData() {
      const sendObj = {}
      sendObj.stockLog = { ...this.stock, type: 1 }
      sendObj.stockLog.displayMile = parseInt(sendObj.stockLog.displayMile)
      sendObj.stockLog.takeOverManager = parseInt(
        sendObj.stockLog.takeOverManager,
      )

      sendObj.stockLog.id = parseInt(this.stockId)
      sendObj.stockLog.carId = parseInt(this.carId)
      sendObj.stockLog.type = 1
      if (this.checkCarImgData.length) {
        const inspectionAttachment = this.checkCarImgData.map((item) => {
          item.urlList = item.urlList?.map((it) => it.url)
          return item
        })
        sendObj.stockLog.inspectionAttachment = JSON.stringify(inspectionAttachment)
      } else {
        sendObj.stockLog.inspectionAttachment = ''
      }
      if (this.aboutCarImgsData.length) {
        const photo = this.aboutCarImgsData.map((item) => {
          item.urlList = item.urlList?.map((it) => it.url)
          return item
        })
        sendObj.stockLog.photo = JSON.stringify(photo)
      } else {
        sendObj.stockLog.photo = ''
      }
      sendObj.receivableInfos = []
      //  因为改了入参，所以改变下数据结构
      Object.keys(sendObj.stockLog).forEach((key) => {
        sendObj[key] = sendObj.stockLog[key]
      })
      return sendObj
    },
  },
}
</script>
<style lang="scss" scoped>
.car-details {
  height: 100%;
  .item.info,
  .dialogwrap-add {
    ::v-deep .el-input--small {
      width: 205px;
    }
  }
  .float-right {
    float: right;
  }
  .sumbit-btns {
    text-align: center;
  }
}
.fileUpload {
  display: flex;
  .txt {
    padding-right: 12px;
    width: 149px;
    box-sizing: border-box;
    text-align: right;
    color: #333;
  }
}
.photoUpload {
  margin-top: 15px;
  display: flex;
  .txt {
    padding-right: 12px;
    width: 149px;
    box-sizing: border-box;
    text-align: right;
  }
}
.uploadCommon_container{
  display: flex;
}
.imgList{
  padding-right: 12px;
  box-sizing: border-box;
  text-align: right;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  .imgList_summay{
    display: flex;
    align-items: flex-start;
  }
}
.imgList ::v-deep .upload-box .notextType-box .upload-text{
  display: none !important;
}
.hideAdd ::v-deep .upload.notextType{
  display: none !important;
}
::v-deep .el-form-item__content {
  width: 200px;
}
::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 200px;
}
::v-deep .el-input--small {
  width: 200px;
}
.form-item-tips{
  font-size: 12px;
  color: #666;
  line-height: 20px;
}
</style>
